import CircularProgress, { circularProgressClasses } from '@zenbusiness/zui/CircularProgress';
import Paper from '@zenbusiness/zui/Paper';
import { superstyled } from '@zenbusiness/zui/styles';

import { keyframes, css } from '@mui/system';

import LoadingZBLogo from './LoadingZBLogo';

export const Root = superstyled({
  name: 'LoadingPage',
  slot: 'Root',
  tag: Paper,
  styles: {
    inset: 0,
    position: 'fixed',
    zIndex: '1000',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

export const Container = superstyled({
  name: 'LoadingPage',
  slot: 'Container',
  styles: {
    alignSelf: 'stretch',
    justifySelf: 'stretch',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

export const Spinner = superstyled({
  name: 'LoadingPage',
  slot: 'Spinner',
  styles: {
    display: 'grid',
    gridTemplateColumns: '10% 1fr 10%',
    gridTemplateRows: '10% 1fr 10%',
    gridColumnGap: '0px',
    gridRowGap: '0px'
  }
});

export const Logo = superstyled({
  name: 'LoadingPage',
  slot: 'Logo',
  tag: LoadingZBLogo,
  styles: {
    maxWidth: '100%',
    gridArea: '2 / 2 / 3 / 3'
  }
});

const circularDashKeyframe = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 150px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 175px, 200px;
    stroke-dashoffset: -125px;
  }
`;

export const Progress = superstyled({
  name: 'LoadingPage',
  slot: 'Progress',
  tag: CircularProgress,
  styles: {
    //  This color must be hardcoded because this spinner gets used before the theme loads
    color: '#33f28b', // growth20.
    animationDuration: '2000ms',
    [`& .${circularProgressClasses.circle}`]: css`
      animation: ${circularDashKeyframe} 2s ease-in-out infinite;
      stroke-linecap: round;
    `,
    gridArea: '1 / 1 / 4 / 4'
  }
});
